module.exports = __webpack_public_path__ + "img/rhino.73f5617e.jpg";